// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
export var DesignComponentPropertyType;
(function (DesignComponentPropertyType) {
    DesignComponentPropertyType["Boolean"] = "Boolean";
    DesignComponentPropertyType["InstanceSwap"] = "InstanceSwap";
    DesignComponentPropertyType["Text"] = "Text";
    DesignComponentPropertyType["Variant"] = "Variant";
})(DesignComponentPropertyType || (DesignComponentPropertyType = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DesignComponentPropertyDefinition {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.id = model.id;
        this.name = model.name;
        this.options = model.type === "Variant" ? model.options : null;
    }
}
export class DesignComponentPropertyBoolean extends DesignComponentPropertyDefinition {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        super(model);
        this.type = DesignComponentPropertyType.Boolean;
        this.defaultValue = model.defaultValue;
    }
}
export class DesignComponentPropertyText extends DesignComponentPropertyDefinition {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        super(model);
        this.type = DesignComponentPropertyType.Text;
        this.defaultValue = model.defaultValue;
    }
}
export class DesignComponentPropertyInstanceSwap extends DesignComponentPropertyDefinition {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a;
        super(model);
        this.type = DesignComponentPropertyType.InstanceSwap;
        this.defaultValue = model.defaultValue;
        if (model.defaultValuePreview) {
            this.defaultValuePreview = {
                componentName: model.defaultValuePreview.componentName,
                componentSetName: (_a = model.defaultValuePreview.componentSetName) !== null && _a !== void 0 ? _a : null,
                isRemote: model.defaultValuePreview.isRemote,
            };
        }
        else {
            this.defaultValuePreview = null;
        }
    }
}
export class DesignComponentPropertyVariant extends DesignComponentPropertyDefinition {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        super(model);
        this.type = DesignComponentPropertyType.Variant;
        this.defaultValue = model.defaultValue;
        this.options = model.options;
    }
}
export function resolveComponentPropertyDefinition(model = {}) {
    return Object.values(model).reduce((acc, propertyDefinition) => {
        switch (propertyDefinition.type) {
            case "Boolean":
                acc.push(new DesignComponentPropertyBoolean(propertyDefinition));
                break;
            case "Text":
                acc.push(new DesignComponentPropertyText(propertyDefinition));
                break;
            case "Variant":
                acc.push(new DesignComponentPropertyVariant(propertyDefinition));
                break;
            case "InstanceSwap":
                acc.push(new DesignComponentPropertyInstanceSwap(propertyDefinition));
                break;
            default:
                break;
        }
        return acc;
    }, []);
}
